import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  controlClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  controlClassName,
  icon,
  iconClassName = 'field-icon',
  className,
  ...rest
}, ref) => {
  const inputNode = <input ref={ref} className={className} {...rest} />;

  if (!icon) {
    return inputNode;
  }

  return (
    <div className={controlClassName}>
      <span className={iconClassName} aria-hidden="true">
        {icon}
      </span>
      {inputNode}
    </div>
  );
});

Input.displayName = 'Input';

export { Input };
